<form [formGroup]="termsOfUseForm">
    <section class="terms-of-use-container">
        <mat-checkbox formControlName="termsOfUse" class="mat-small" required color="primary">
            To continue, please accept our
            <a [href]="termsOfUseURL | sanitize: 'url'" target="_blank" id="terms-of-use"> Terms of Use </a>
        </mat-checkbox>
        @if (showError && termsOfUseForm.invalid && termsOfUseForm.touched) {
            <mat-error>
                <app-field-error [field]="'termsOfUse'" [messageList]="formError['termsOfUse']" />
            </mat-error>
        }
    </section>
</form>
